import React from 'react';
import '../assets/css/ImageOverlayCardGroup.css'; // CSS file import

// Importing local images
import PrinterIcon from '../assets/images/icon/printer.png';
import WifiIcon from '../assets/images/icon/wifi.png';
import LaptopIcon from '../assets/images/icon/icon1.png';
import SyncIcon from '../assets/images/icon/sync.png';

const ImageOverlayCardGroup = () => {
  const cardData = [
    {
      number: '01',
      image: PrinterIcon, // Local image
      iconClass: '', // No icon if image exists
      title: 'Simple and Smart Solutions',
      // link: 'https://techtotalers.in/project/simple-and-smart-solutions/',
    },
    {
      number: '02',
      image: WifiIcon, // Local image
      iconClass: '',
      title: 'Cost Effective Development',
      // link: 'https://techtotalers.in/project/cost-effective-development/',
    },
    {
      number: '03',
      image: LaptopIcon, // Local image
      iconClass: '',
      title: 'Innovation & New Ideas',
      // link: 'https://techtotalers.in/project/innovation-new-ideas/',
    },
    {
      number: '04',
      image: SyncIcon, // Local image
      iconClass: '',
      title: 'IT Services',
      // link: 'https://techtotalers.in/project/it-services/',
    },
  ];

  return (
    <section className="feature-section">
      <div className="section-title text-center">
        <div className="section-title__tagline-box">
          <span className="section-title__tagline">Process</span>
        </div>
        <h2 className="section-title__title">
          How <span>We Work</span>
        </h2>
      </div>
      <div className="feature-card-group">
        {cardData.map((card, index) => (
          <div className="feature-card" key={index}>
            <div className="card-number">
              <span>{card.number}</span>
            </div>
            <div className="card-icon">
              {card.image ? (
                <img src={card.image} alt={card.title} />
              ) : (
                <i className={`flaticon ${card.iconClass}`} aria-hidden="true"></i>
              )}
            </div>
            <h4 className="card-title">
              <a href={card.link} target="_blank" rel="noopener noreferrer">
                {card.title}
              </a>
            </h4>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ImageOverlayCardGroup;
